module.exports = __webpack_public_path__ + "static/Kiwok_Logo_White-7a0b0e143f8271a915098c9c7b3c0f88.png";